export const LoggingLevel = {
  Info: "info",
  Warning: "warning",
  Error: "error",
  Fatal: "fatal",
}
